export function resolveInstallOrder<TId extends string>(
  ids: TId[],
  getDependencies: (id: TId) => TId[],
  noun: string
): TId[] {
  const ordered: TId[] = []
  const visiting = new Set<TId>()
  const visited = new Set<TId>()

  function visit(id: TId): void {
    if (visited.has(id)) {
      return
    }
    if (visiting.has(id)) {
      throw new Error(`Circular ${noun} dependency detected at "${id}".`)
    }

    visiting.add(id)
    for (const dependency of getDependencies(id)) {
      visit(dependency)
    }
    visiting.delete(id)
    visited.add(id)
    ordered.push(id)
  }

  for (const id of ids) {
    visit(id)
  }

  return ordered
}
